import EncryptHelper from "./encryptHelper";

const cacheHelper = {

  get: key => EncryptHelper.decrypt(localStorage.getItem(key)),

  set: (key, data) => {
    const dataEncrypted = EncryptHelper.encrypt(data);
    localStorage.setItem(key, dataEncrypted);
  },

  remove: key => localStorage.removeItem(key),

  clear: () => localStorage.clear()

};

export default cacheHelper;
